var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('v-container',[_c('p',{staticClass:"copyright"},[_vm._v("© "+_vm._s(_vm.currentYear)+" Anderson Saraiva Lima. Todos os direitos reservados.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }